import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito computadora?',
  a: 'No. Puedes hacerlo todo desde tu celular.'
}, {
  q: '¿Y si no tengo idea qué PDF crear?',
  a: 'Te damos ideas listas para usar y vender.'
}, {
  q: '¿Tengo que ser buena escribiendo?',
  a: 'No. Tendrás textos guía para copiar y pegar.'
}, {
  q: '¿Dónde lo vendo?',
  a: 'En WhatsApp, Instagram o donde tengas conexión.'
}, {
  q: '¿Esto funciona si tengo pocos seguidores?',
  a: 'Sí. Esto está pensado justo para empezar desde cero.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-8 px-4 md:px-6 bg-white" data-id="element-58">
      <div className="max-w-xl mx-auto" data-id="element-59">
        {/* FAQ Card Container */}
        <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] p-4 md:p-5" data-id="element-60">
          {/* Header */}
          <h2 className="text-xl font-bold text-[#1A1A1A] text-center mb-4" data-id="element-61">
            Preguntas Frecuentes
          </h2>

          {/* FAQ Items */}
          <div className="space-y-2" data-id="element-62">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={index} className={`rounded-xl border overflow-hidden transition-colors duration-200 ${isOpen ? 'border-[#FFD1DC] bg-[#FFF0F3]' : 'border-gray-200 bg-white'}`} data-id="element-63">
                  <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between p-3 text-left" aria-expanded={isOpen} data-id="element-64">
                    <span className="text-sm font-semibold text-[#222222] pr-2" data-id="element-65">
                      {faq.q}
                    </span>
                    {isOpen ? <ChevronUp className="w-4 h-4 text-[#CC0055] flex-shrink-0" data-id="element-66" /> : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-67" />}
                  </button>

                  <AnimatePresence initial={false} data-id="element-68">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: 'easeInOut'
                }} data-id="element-69">
                        <div className="px-3 pb-3" data-id="element-70">
                          <p className="text-sm text-[#555555] leading-relaxed" data-id="element-71">
                            {faq.a}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}